import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useHistory } from "react-router-dom";
import { getManagerInfo, getNominatorInfo, getUserCity, getUserCompany, validateNominee } from './services';
import { getCategoryMap, getFirstName, getIsAdminExists, getMiddleName, getNominatorId, getNominatorMail, setadminDetails, setisAdminSelected } from './common';
import { Alert, AlertTitle } from '@material-ui/lab';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
// import { AddAdminSearchHandle } from "./AddAdmin";
import { Modal } from '@material-ui/core';
import { data } from './local';
import { useSelector } from 'react-redux';
interface CountryType {
  name: string;
  id: any;
  jobTitle?: string;
}
function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}



export const UserImage: FunctionComponent<any> = ({ id, token }: any) => {

  const [image, setImage] = useState<any>();
  useEffect(() => {
    let url = `https://graph.microsoft.com/v1.0//users/${id}/photo/$value`;
    let icon;
    (async () => {
      if (token) {
        icon = fetch(url, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            "Content-Type": "image/jpg"
          },
        }).then(async (response: any) => {
          if (response.ok) {
            return response.blob();
          }
          if (response?.status == 200) {
            let data = response.body
          }
        }).then((photoBlob: any) => {
          let icon;
          if (photoBlob) {
            icon = URL.createObjectURL(photoBlob);
            setImage(icon)
          } else {
            icon = "/images/758772.svg";
          }
        });
      }
    })();


  }, [id, token])
  return image ? <img id={id} style={{
    width: "44px",
    height: "inherit",
    margin: "auto",
    borderRadius: "50%",
    marginRight: "5px"

    // width: "39px",
    // borderRadius: "20px"
  }} src={image} alt="noImage" /> :


    <AccountCircleIcon style={{
      height: "50px",
      width: "50px",
      borderRadius: "20px"
    }} />
  // <div style={{
  //   width: "45px",
  //   height: "45px",
  //   borderRadius: "50%",
  //   background: "grey"
  // }}></div>
}

const AdminSearchBox: FunctionComponent<any> = ({ title, token}: any) => {

  const [value, setValue] = useState<any>();  
  const [newAdminDetails, setNewAdminDetails] = useState<any>();  
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<CountryType[]>([{ name: "India", id: "ds" }, { id: "dsad", name: "USA" }]);
  const loading = open && options.length === 0 && value;
  const [isLoading, setLoading] = useState<boolean>(false);
  React.useEffect(() => {
    let active = true;
    let filter = `(startswith(displayName,'${value}') or startswith(givenName,'${value}') or startswith(surname,'${value}') or startswith(mail,'${value}') or startswith(userPrincipalName,'${value}')) and (mail ne null)`;
    if (value) {
      // return undefined;
      setLoading(true);
    } else {
      setLoading(false);
    }
    if(value!=undefined){
      if(value.length>=3){
    (async () => {
      var url = "https://graph.microsoft.com/v1.0/users?$count=true&$orderby=displayName&$filter="+filter;
      if (token) {
        fetch(url, {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
            'ConsistencyLevel': 'eventual'
          },
        }).then(async (response: any) => {
       
          const data = await response.json()
          if (active) {
            if (data?.value?.length > 0) {
              setOptions(data?.value.map((user: any) => {
                const { mail,
                  officeLocation,
                  surname } = user;

                return ({
                  name: user.displayName,
                  id: user.id,
                  jobTitle: user.jobTitle,
                  mail,
                  officeLocation,
                  surname
                })
                // return user
              }) as CountryType[]);
              setLoading(false);
            } else {
              setLoading(false);
              setOptions([]);
            }

          }
        })
      }
    })();
  }
}
    return () => {
      active = false;
    };
  }, [value]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
      setisAdminSelected(false);
    }
  }, [open]);

  let history = useHistory();
  

  const nomineeHandler = async (option: any, searchBox: any) => {
    let userInfo: any = await getNominatorInfo(option.id);
    let managerInfo: any = await getManagerInfo(option.id);
    let userInfoCompany: any = await getUserCompany(option.id);
    let userInfoCity: any = await getUserCity(option.id);
    const { displayName, mail, officeLocation, jobTitle,givenName,surname } = userInfo;

    if (getNominatorMail() === mail) {
      setError(true)
      setAlertTitle(searchBox.selfNominatingAdmin)
      return;
    }

    let nomineeOption = {
      "firstName": givenName,
      "lastName": surname,
      "middleName": '',
      "displayName":displayName,
      "email": mail,
      "city": userInfoCity.value,
      "company": userInfoCompany.value,
      "title": jobTitle,
      "managerName": managerInfo.displayName,
      "managerEmail": managerInfo.mail,
      "graphId": option.id,
      "RoleId":1
    }
    setisAdminSelected(true);
    setadminDetails(nomineeOption);
  }
  const [showError, setError] = useState<boolean>(false)
  const [alertTitle, setAlertTitle] = useState<string>('')
  const [alertMessage, setAlertMessage] = useState<string>('')
  const [msgType, setMsgType] = useState<string>('')
  const [userNotFoundMsg, setUserNotFoundMsg] = useState<string>('')
  let AdminSearchBox  = 
  {
    selfNominatingAdmin:'You are an Admin already. Please make another selection.',
    userNotFound:`No user found.`
  };
  useEffect(() => {
    setAlertTitle(AdminSearchBox.selfNominatingAdmin)
    setUserNotFoundMsg(AdminSearchBox.userNotFound)
    }, [])

  return (
    <>

      <Autocomplete
        inputValue={value}
        onInputChange={(event, newInputValue) => {
          setError(false)
          setOptions([])
          setValue(newInputValue);
          setisAdminSelected(true);
        }}
        freeSolo={value ? false : true}
        noOptionsText={<div > 
          <span style={{ color: "#3f51b5" }} >           
            {userNotFoundMsg}
          </span>       
        </div>}
        id="search"
        style={{ width: "60%" , backgroundColor:"#FFFFFF"}}
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
            setOpen(false)
        }}
        getOptionSelected={(option: any, value: any) => option.name === value.name}
        getOptionLabel={(option: any) => option.name}
        options={options}
        loading={isLoading}
        renderOption={(option: any) => {
          
          return <div style={{ display: "flex", width: "100%" }} onClick={() =>{{ nomineeHandler(option, AdminSearchBox) } }}>
            
            <UserImage id={option.id} token={token} />
            <div style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "5px",
              width: "100%",
              justifyContent: "space-between"

            }}>
              <div style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "5px"

              }}>
                <div style={{
                  margin: "auto",
                  // marginLeft: "14px",

                }}> {option.name.trim(" ")}</div>
                <div style={{ fontSize: "11px" }}>{option?.jobTitle}</div>
                <div style={{ fontSize: "11px" }}>{option?.officeLocation}</div>
              </div>
            </div>
          </div>
        }}
        renderInput={(params: any) => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <DescriptionAlerts show={showError} error={alertTitle} message={alertMessage} onClose={() => {
        setError(false.valueOf)
      }} />
    </>
  );
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& > * + *': {
        marginTop: theme.spacing(2),
      },
      transform: "translateZ(10px)",
      zIndex: 999999999,
      boxShadow: "1px 0px 8px #878282",
      position: "relative",
      top: "5px"
    },
    hidden: {
      display: "none"
    },
  }),
);

export function DescriptionAlerts({ show, error, message }: any) {
  const classes = useStyles();

  return (
    <div className={show ? classes.root : classes.hidden}>
      <Alert severity="error">
        <AlertTitle>{error}</AlertTitle>
        {message}
      </Alert>

    </div>
  );
}


export default AdminSearchBox;